import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SplashScreenService } from './splash-screen/splash-screen.service';

@Component({
  selector: 'app-root',
  template: `
    <app-splash-screen [isLoading]="isLoading"></app-splash-screen>
    <div class="app-content" [class.hidden]="isLoading">
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLoading = true;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private splashScreenService: SplashScreenService
  ) {
    this.matIconRegistry.addSvgIcon(
      'saas-commerce',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/logo.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'datakama-logo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/datakamalogo.svg')
    );
  }

  ngOnInit() {
    // Subscribe to splash screen service
    this.splashScreenService.isLoading$.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  title = 'application';
}
